import * as api from '../services/API';
import { actions } from '../ducks/Boards';
import onError from './Error';

export const fetchBoards = ({ communityId, roomId }: { communityId: string; roomId: string }) => {
  return async (dispatch: any) => {
    dispatch(actions.fetchBoardsRequest({ communityId, roomId }));

    try {
      const boards = await api.fetchBoards({ communityId, roomId });

      return dispatch(actions.fetchBoardsSuccess({ boards }));
    } catch (error) {
      return onError({ error, dispatch, action: actions.fetchBoardsError({ error }) });
    }
  };
};

export const fetchActiveBoard = ({
  communityId,
  roomId,
  boardId,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
}) => {
  return async (dispatch: any) => {
    dispatch(actions.fetchActiveBoardRequest({ id: boardId }));

    try {
      const activeBoard = await api.fetchBoard({ communityId, roomId, boardId });

      return dispatch(actions.fetchActiveBoardSuccess({ activeBoard }));
    } catch (error) {
      return onError({ error, dispatch, action: actions.fetchActiveBoardError({ error }) });
    }
  };
};

export const fetchRoomMembers = ({
  communityId,
  roomId,
  boardId,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
}) => {
  return async (dispatch: any) => {
    dispatch(actions.fetchRoomMembersRequest({ communityId, roomId }));

    try {
      const roomMembers = await api.getAllRoomMembers({ communityId, roomId, boardId });

      return dispatch(actions.fetchRoomMembersSuccess({ roomMembers }));
    } catch (error) {
      return onError({ error, dispatch, action: actions.fetchRoomMembersError({ error }) });
    }
  };
};
